import type { MouseEvent } from 'react'
import { ButtonLink } from '@/components/play'
import { oauthStartUrl } from '@/components/onboarding/authContinuation'
import { GoogleMark, StravaMark } from '@/components/onboarding/ProviderMarks'

const PROVIDERS = [
  { id: 'google', name: 'Google', Mark: GoogleMark },
  { id: 'strava', name: 'Strava', Mark: StravaMark },
] as const

/** Google and Strava, as links to their sign-in, under an "or". While another sign-in is under way they stay in place,
 *  focusable but held (`disabled`), as a BackLink is. */
export function SocialSignIn({ returnTo, disabled }: { returnTo: string; disabled?: boolean }) {
  const hold = (event: MouseEvent<HTMLAnchorElement>) => {
    if (disabled) event.preventDefault()
  }
  return (
    <div className="space-y-3">
      <p className="play-entry-or">or</p>
      <div className="grid grid-cols-2 gap-3">
        {PROVIDERS.map(({ id, name, Mark }) => (
          <ButtonLink
            key={id}
            variant="secondary"
            href={oauthStartUrl(id, returnTo)}
            aria-label={`Continue with ${name}`}
            aria-disabled={disabled || undefined}
            data-disabled={disabled ? '' : undefined}
            onClick={hold}
          >
            <Mark />
            {name}
          </ButtonLink>
        ))}
      </div>
    </div>
  )
}
